/**
 * App — root component.
 *
 * On mount, if we have a persisted access token but no profile (page refresh),
 * we rehydrate by calling /admin/auth/me. On 401 the axios interceptor clears
 * the store and the router punts to /login.
 */
import { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { api } from './api/client';
import { useAuthStore } from './store/auth';
import { AppRouter } from './router';

export default function App() {
  const accessToken = useAuthStore((s) => s.accessToken);
  const profile = useAuthStore((s) => s.profile);
  const setProfile = useAuthStore((s) => s.setProfile);
  const clear = useAuthStore((s) => s.clear);
  const [bootstrapping, setBootstrapping] = useState<boolean>(Boolean(accessToken && !profile));

  useEffect(() => {
    if (accessToken && !profile) {
      api
        .get('/api/admin/auth/me')
        .then((p) => setProfile(p as never))
        .catch(() => clear())
        .finally(() => setBootstrapping(false));
    }
  }, [accessToken, profile, setProfile, clear]);

  if (bootstrapping) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return <AppRouter />;
}
